(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/accountservices-react/deposit/assets/react/swedbank-express/pages/expired-consent/expired-consent.js') >= 0) return;  svs.modules.push('/components/accountservices-react/deposit/assets/react/swedbank-express/pages/expired-consent/expired-consent.js');
'use strict';

const {
  ExpiredConsentInfo,
  ConsentInfo
} = svs.accountservicesReact.deposit.swedbankExpress.sharedComponents;
const Button = svs.ui.ReactButton;
const {
  ReactInfoButtonText
} = svs.tb_ui;
const {
  showExpressMoreInformationAsync
} = svs.accountservicesReact.deposit.dialogs.swedbankExpressDialogs;
const ExpiredConsent = _ref => {
  let {
    onClick
  } = _ref;
  const handleGetBankAccount = () => {
    onClick();
  };
  const handleShowMoreInfo = () => {
    showExpressMoreInformationAsync();
  };
  return React.createElement("div", {
    className: "margin-top-2"
  }, React.createElement(ExpiredConsentInfo, null), React.createElement(ReactInfoButtonText, {
    onClick: handleShowMoreInfo,
    text: "L\xE4s mer om Expressbetalning"
  }), React.createElement(Button, {
    block: true,
    className: "margin-top-2",
    focus: true,
    onClick: handleGetBankAccount
  }, "Identifiera"), React.createElement(ConsentInfo, null));
};
svs.accountservicesReact.deposit.swedbankExpress.pages.expiredConsent.ExpiredConsent = ExpiredConsent;

 })(window);